import { IContentSource } from "../drawing";
import { NameSpecifiedEntity } from "../entity";
import { Company, QuoteBehaviorKinds } from ".";

export class FormatReference extends NameSpecifiedEntity<number> {
  constructor(
    id: number,
    name: string,
    public previewSource: IContentSource,
    public thumbnailSource: IContentSource,
    public reportTypeId: number = null,
    public masterCode: string = null,
    public tag: string = null,
    public company: Company = null,
    public categoryType: string = null,
    public writeMethodType: string = null,
    public startDateTime: string = null,  // TODO: 誰も使ってない.要見直し.本当に必要ならDate型にすべき.
    public endDateTime: string = null,    // TODO: 誰も使ってない.要見直し.本当に必要ならDate型にすべき.
    public expired: boolean = false,
    public deleted: boolean = false,
    public editedName: string = null,
    public originalName: string = null,
    public note: string = null,
    public quoteBehaviorKind: QuoteBehaviorKinds = null) {
      super(id, name);
  }

  clone() {
    return new FormatReference(
      this.id,
      this.name,
      this.previewSource ? this.previewSource.clone() : null,
      this.thumbnailSource ? this.thumbnailSource.clone() : null,
      this.reportTypeId,
      this.masterCode,
      this.tag,
      this.company ? this.company.clone() : null,
      this.categoryType,
      this.writeMethodType,
      this.startDateTime ? this.startDateTime : null,
      this.endDateTime ? this.endDateTime : null,
      this.expired,
      this.deleted,
      this.editedName,
      this.originalName,
      this.note,
      this.quoteBehaviorKind,
    );
  }
}
